document.addEventListener('DOMContentLoaded', function () {
    const signupForm = document.querySelector('.signup-form');
    const signupContinueBtn = document.getElementById('signup-continue-button');
    const optionalFieldsets = document.querySelector('.optionalFieldsets');
    
    const emailInput = document.querySelector('blox-input[name="email"]');
    const confirmEmailInput = document.querySelector('blox-input[name="email_verify"]');
    const passwordInput = document.querySelector('blox-input[name="password"]');
    const phoneInput = document.querySelector('blox-input[name="phone"]');
    
    
    function maskPhoneNumber() {
        let phoneNumber = phoneInput.value.replace(/\D*/g, "");
        if (phoneNumber.length >= 3) { phoneNumber = "(" + phoneNumber.slice(0, 3) + ") " + phoneNumber.slice(3); }
        if (phoneNumber.length >= 9) { phoneNumber = phoneNumber.slice(0, 9) + "-" + phoneNumber.slice(9); }
        phoneInput.value = phoneNumber;
    };
    
    async function firstFieldsetCheckValidity() {
        if (await emailInput.checkValidity() && await passwordInput.checkValidity()) {
            if (confirmEmailInput) return await confirmEmailInput.checkValidity();
            return true;
        } else {
            return false;
        }
    }
    
    async function firstFieldsetReportValidity() {
        await passwordInput.checkValidity() ? null : passwordInput.reportValidity();
        if (confirmEmailInput) {
            await confirmEmailInput.checkValidity() ? null : confirmEmailInput.reportValidity();
        }
        await emailInput.checkValidity() ? null : emailInput.reportValidity();
    }
    
    async function firstFieldsetAttemptSubmit() {
        if (await firstFieldsetCheckValidity() === true) {
            if (optionalFieldsets.hasChildNodes() && !optionalFieldsets.classList.contains('open')) {
                optionalFieldsets.classList.add('open');
            } else {
                signupForm.requestSubmit();
            }
        } else {
            firstFieldsetReportValidity();
        };
    }

    [emailInput, confirmEmailInput, passwordInput].forEach(input => {
        input?.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                firstFieldsetAttemptSubmit();
            }
        });
    });
    
    signupContinueBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        firstFieldsetAttemptSubmit();
    });

    signupForm.addEventListener('submit', (e) => {
        e.preventDefault();
        var recaptchaInput = document.querySelector('#signup-recaptcha-token');

        if (typeof grecaptcha == 'undefined') return;
        if (recaptchaInput) {
            grecaptcha.enterprise.ready(function () {
                grecaptcha.enterprise.execute(recaptchaInput.dataset.key, { action: 'signup' })
                    .then(function (token) {
                        recaptchaInput.value = token;
                        signupForm.submit();
                    });
            });
        } else {
            signupForm.submit();
        }
    });

    if (confirmEmailInput) {
        emailInput.addEventListener('blur', () => {
            confirmEmailInput.pattern = emailInput.value;
        });
    }

    phoneInput?.addEventListener('keypress', () => {
        maskPhoneNumber();
    });
    
    phoneInput?.addEventListener('blur', () => {
        maskPhoneNumber();
    });
    
});